'use strict';

class AdFlowProcessSpinner {
  constructor() {
    this.adContainer = window.document.body;
  }
  show = function (e) {
    ((this.adSpinner.style.display = 'block'),
      (this.adSpinnerOverlay.style.display = 'block'),
      e
        ? ((this.adSpinner.style.display = 'block'),
          (this.adSpinnerFail.style.display = 'none'),
          (this.adSpinnerButton.style.display = 'none'))
        : ((this.adSpinner.style.display = 'none'),
          (this.adSpinnerFail.style.display = 'block'),
          (this.adSpinnerButton.style.display = 'block')));
  };
  hide = function () {
    ((this.adSpinner.style.display = 'none'), (this.adSpinnerOverlay.style.display = 'none'));
  };
  add = function () {
    try {
      this.addStyles();
      var t = document.createElement('div'),
        n =
          ((t.id = 'gd__spinner'),
          t.setAttribute('title', 'Spinner'),
          t.classList.add('gd__spinner'),
          (this.adSpinner = t),
          document.createElement('div')),
        r =
          ((n.id = 'gd__spinner__fail'),
          n.setAttribute('title', 'Spinner'),
          n.classList.add('gd__spinner__fail'),
          (n.innerHTML = 'No Ads Available!'),
          (this.adSpinnerFail = n),
          document.createElement('div')),
        o =
          ((r.id = 'gd__spinner__button'),
          r.setAttribute('title', 'Spinner'),
          r.classList.add('gd__spinner__button'),
          (r.onclick = function () {
            this.hide();
          }.bind(this)),
          document.createElement('p')),
        i =
          ((o.innerText = 'OK!'),
          r.appendChild(o),
          (this.adSpinnerButton = r),
          document.createElement('div')),
        a =
          ((i.id = 'gd__spinner__logo'),
          i.setAttribute('title', 'Spinner'),
          i.classList.add('gd__spinner__logo'),
          (this.adSpinnerLogo = i),
          document.createElement('div')),
        s =
          ((a.id = 'gd__spinner__container'),
          a.classList.add('gd__spinner__container'),
          a.appendChild(this.adSpinner),
          a.appendChild(this.adSpinnerFail),
          a.appendChild(this.adSpinnerButton),
          a.appendChild(this.adSpinnerLogo),
          (this.adSpinnerContainer = a),
          document.createElement('div'));
      ((s.id = 'gd__spinner__overlay'),
        s.classList.add('gd__spinner__overlay'),
        s.appendChild(this.adSpinnerContainer),
        (this.adSpinnerOverlay = s),
        this.adContainer.appendChild(this.adSpinnerOverlay));
    } catch (e) {
      console.log('Spinner error', e);
    }
  };
  addStyles = function () {
    var e = document.body || document.getElementsByTagName('body')[0];
    this.addStylesheet(
      'gd__spinner__style',
      e,
      `
			.gd__spinner__button {
				text-align: center;
				width: 150px;
				height: 50px;
				position: absolute;
				display: none;
				z-index: 2000;
				cursor: pointer;
				top: calc(80% - 25px);
				left: calc(50% - 75px);
				margin: 0;
				font-size: large;
				font-family: monospace;
				background-color: #ff8c1c;
				border-radius: 50px;
				color: white;
			}
			.gd__spinner__fail{
				text-align: center;
				width: 300px;
				height: 50px;
				position: absolute;
				display: none;
				z-index: 2000;
				cursor: pointer;
				top: calc(65% - 25px);
				left: calc(50% - 150px);
				margin: 0;
				font-size: large;
				font-family: monospace;
				color: #ff8c1c;
			}
			.gd__spinner__logo{
				background: url("https://static.gamedistribution.com/android-chrome-192x192.png") no-repeat;
				background-size: cover;
				width: 100px;
				height: 100px;
				position: absolute;
				display: block;
				z-index: 2000;
				cursor: pointer;
				top: calc(30% - 50px);
				left: calc(50% - 50px);
				margin: 0;
				border-radius: 50%;
			}
			.gd__spinner__container{
				background-color: black;
				width: 300px;
				height: 300px;
				position: absolute;
				z-index: 2000;
				cursor: pointer;
				top: calc(50% - 150px);
				left: calc(50% - 150px);
				margin: 0;
				border-radius: 20px;
				border: 2px solid #06b8a2;
			}
			.gd__spinner{
				background: url("https://static.gamedistribution.com/assets/loader.gif") no-repeat;
				background-size: cover;
				width: 50px;
				height: 50px;
				position: absolute;
				display: none;
				z-index: 2000;
				cursor: pointer;
				top: calc(80% - 25px);
				left: calc(50% - 25px);
				margin: 0;
				border-radius: 50%;
			}
			.gd__spinner__overlay {
				position: fixed;
				display: none;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background-color: rgba(0,0,0,0.5);
				z-index: 1999;
				cursor: pointer;
			}`,
    );
  };
  addStylesheet = function (e, t, n) {
    var r;
    document.getElementById(e) ||
      (((r = document.createElement('style')).type = 'text/css'),
      (r.id = e),
      r.styleSheet ? (r.styleSheet.cssText = n) : r.appendChild(document.createTextNode(n)),
      t.appendChild(r));
  };
}

export default AdFlowProcessSpinner;
